import { render } from "./CountIzin.vue?vue&type=template&id=566cbd30"
import script from "./CountIzin.vue?vue&type=script&lang=js"
export * from "./CountIzin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__